if (!customElements.get('sole-spa-catalog')) {
  customElements.define('sole-spa-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;
      this.listenerController = new AbortController();
      const options = { signal: this.listenerController.signal };
      const buttons = [...this.querySelectorAll('[data-filter]')];
      const groups = [...this.querySelectorAll('[data-group]')];
      const apply = value => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
        groups.forEach(group => { group.hidden = value !== 'all' && group.dataset.group !== value; });
        this.querySelector('.sp-menu-grid').dataset.filtered = String(value !== 'all');
      };
      buttons.forEach(button => {
        if (button.dataset.filter !== 'all' && !groups.some(group => group.dataset.group === button.dataset.filter)) button.hidden = true;
        button.addEventListener('click', () => apply(button.dataset.filter), options);
      });
      document.addEventListener('shopify:block:select', event => {
        const block = [...this.querySelectorAll('[data-block-id]')].find(item => item.dataset.blockId === event.detail?.blockId);
        if (!block) return;
        apply('all');
        block.scrollIntoView({ block: 'center', behavior: 'auto' });
      }, options);
    }
    disconnectedCallback() {
      this.listenerController?.abort();
      this.listenerController = null;
    }
  });
}
